
export const isCSSDomain = () => {
  const domain = window.location.hostname;
  if (domain.includes('travelers.com')) {
    return false;
  }

  if (domain.includes('constitutionstateservices.com')) {
    return true;
  }
  return false;
};

export default { isCSSDomain };
